<div id="adoptUnprocessableParcelToClientModal" class="adoptUnprocessableParcelToClientModal" uk-modal>
  <div class="uk-modal-dialog">
    <button class="uk-modal-close-default" type="button" uk-close></button>

    <div class="uk-modal-header">
      <h2 class="uk-modal-title">{{'Wymuś przypisanie do klienta' | translate}}</h2>
    </div>

    <div class=" uk-modal-body">
      <div class="uk-grid">
        <div class="uk-width-1-2">
          <label>Klient</label>
          <input autocomplete="off" [class.uk-form-danger]="adoptUnprocessableParcelToClientInput.touched && adoptUnprocessableParcelToClientInput.value == ''" (keyup)="searchClient(adoptUnprocessableParcelToClientInput)" type="text" #adoptUnprocessableParcelToClientInput="ngModel" name="adoptUnprocessableParcelToClientInput" [(ngModel)]="clientName" class="uk-input" required #adoptUnprocessableParcelToClientI>
          <div style="position: absolute; max-height: 200px;" class="uk-overflow-auto">
            <ul class="uk-list uk-list-divider uk-position-relative uk-margin-remove-top" style="background-color: white; width: 100%;" *ngIf="clientsList.length > 0" [style.width]="adoptUnprocessableParcelToClientI.clientWidth + 'px'">
              <li *ngFor="let client of clientsList" (click)="setClientData(client);" style="padding-left: 5px!important;">{{client.name}}</li>
            </ul>
          </div>
          <input type="hidden" #forced_client_id="ngModel" autocomplete="none" [(ngModel)]="form.id_client" class="uk-input">
        </div>
        <div class="uk-width-1-4">
          <label title="Przesyłka emag">P.emag</label>
          <select [(ngModel)]="form.is_emag_parcel" name="is_emag_parcel" class="uk-select">
            <option value="1">Tak</option>
            <option value="0">Nie</option>
          </select>
        </div>
        <div class="uk-width-1-4">
          <label title="Przesyłka zwrotna">P. zwrotna</label>
          <select [(ngModel)]="form.return"  name="return" class="uk-select">
            <option value="1">Tak</option>
            <option value="0">Nie</option>
          </select>
        </div>
      </div>

      <div class="uk-margin">
        <button class="uk-button uk-button-primary uk-width-1-1 uk-margin-top" (click)="submit()">Zapisz</button>
      </div>
    </div>
  </div>
</div>
